// extracted by mini-css-extract-plugin
export default {"menu":"LanguageSwitcher_menu__iTWwl"};